"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSocialTwitter = function SvgIconSocialTwitter(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "social twitter icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Social Twitter Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.3 16.287c.022.32.022.64.022.96 0 9.753-7.424 20.992-20.992 20.992A20.85 20.85 0 016 34.926c.594.069 1.165.092 1.782.092 3.449 0 6.624-1.165 9.16-3.153a7.391 7.391 0 01-6.899-5.116c.457.068.914.114 1.394.114.662 0 1.324-.092 1.941-.251a7.38 7.38 0 01-5.916-7.241v-.092a7.43 7.43 0 003.335.937 7.373 7.373 0 01-3.29-6.145c0-1.37.366-2.627 1.006-3.723a20.972 20.972 0 0015.213 7.72 8.329 8.329 0 01-.183-1.69A7.375 7.375 0 0130.921 9a7.36 7.36 0 015.391 2.33 14.526 14.526 0 004.683-1.782 7.358 7.358 0 01-3.244 4.066A14.791 14.791 0 0042 12.472a15.86 15.86 0 01-3.7 3.815z"
  }));
};

var _default = SvgIconSocialTwitter;
exports.default = _default;